import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import api from '../api';

// Hall de entrada dos Documentos. Manual e ata são coisas diferentes (um vale até o
// processo mudar, a outra é o registro de um dia), então cada uma tem a sua porta —
// no mesmo formato de card da tela inicial, de propósito.
export default function DocumentosHall() {
  const [docs, setDocs] = useState(null);
  const [atas, setAtas] = useState({ pastas: 0, atas: 0 });

  useEffect(() => {
    api.get('/categorias')
      .then(({ data }) => setDocs((data.categorias || []).reduce((t, c) => t + (c.qtd_docs || 0), 0)))
      .catch(() => setDocs(0));
    api.get('/atas/resumo').then(({ data }) => setAtas(data)).catch(() => {});
  }, []);

  return (
    <>
      <Header />
      <main className="home-container">
        <div className="home-saudacao">Documentos</div>
        <div className="home-subtitulo">Escolha o que você procura.</div>

        <div className="cards-grid">
          <Link to="/documentos/manuais" className="card-acesso">
            <i className="bi bi-journal-text"></i>
            <div className="titulo">Manuais e POPs</div>
            <div className="descricao">
              {docs === null ? 'Procedimentos, manuais e treinamentos' : `${docs} documento(s) disponíveis pra você`}
            </div>
          </Link>

          {atas.pastas > 0 && (
            <Link to="/atas" className="card-acesso">
              <i className="bi bi-journal-bookmark-fill"></i>
              <div className="titulo">Atas de Reunião</div>
              <div className="descricao">
                {atas.atas} ata(s) em {atas.pastas} {atas.pastas === 1 ? 'reunião' : 'reuniões'}
              </div>
            </Link>
          )}
        </div>
      </main>
    </>
  );
}
